/* RESPONSIBLE TEAM: team-ai-agent-2 */
import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';

class AutomationFinAIAgentChangelogRoute extends Route {
  @service declare intl: IntlService;

  queryParams = {
    search: { refreshModel: false },
    filters: { refreshModel: false },
  };

  analytics = {
    section: 'automation',
    place: 'fin-ai-agent.changelog',
  };

  get titleToken() {
    return this.intl.t('ai-agent.changelog.title');
  }

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(AutomationFinAIAgentChangelogRoute);
